// extracted by mini-css-extract-plugin
export default {"anonymuously_button":"styles_anonymuously_button__wbhZq","anonymuously_output_text":"styles_anonymuously_output_text__P6ci7"};